document.addEventListener('DOMContentLoaded', function () {
    const menuBtn = document.querySelector('.sm-hamburger');
    const header = document.getElementById('sm-header');
    const smMenu = document.querySelector('.sm-menu');
    const toggleClass = 'menu-open';

    // Toggle class on click
    menuBtn.addEventListener('click', function (e) {
        e.stopPropagation(); // Prevent click from bubbling to document
        header.classList.toggle(toggleClass);
    });

    // Click outside to remove class
    document.addEventListener('click', function (e) {
        if (!smMenu.contains(e.target) && !menuBtn.contains(e.target)) {
            header.classList.remove(toggleClass);
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const ctaBtns = document.querySelectorAll('.cta-share');
    const className = 'copied'; // Change this to your preferred class

    ctaBtns.forEach(function (ctaBtn) {
        ctaBtn.addEventListener('click', function (e) {
            e.preventDefault(); // Prevent default anchor behavior

            // Copy current page URL to clipboard
            navigator.clipboard.writeText(window.location.href).then(function () {
                // Add class
                ctaBtn.classList.add(className);

                // Remove class after 5 seconds
                setTimeout(function () {
                    ctaBtn.classList.remove(className);
                }, 5000);
            }).catch(function (err) {
                console.error('Failed to copy URL:', err);
            });
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    const menuLinks = document.querySelectorAll('.sm-menu a[href^="#"]');
    const header = document.getElementById('sm-header');
    const toggleClass = 'menu-open';

    menuLinks.forEach(function(link) {
        link.addEventListener('click', function(e) {
            e.preventDefault();

            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                // Choose offset based on screen width
                const isMobile = window.innerWidth < 768;
                const offset = isMobile ? 64 : 82; // Customize these values as needed

                // Get element position
                const elementTop = targetElement.getBoundingClientRect().top + window.pageYOffset;

                // Scroll to position with offset
                window.scrollTo({
                    top: elementTop - offset,
                    behavior: 'smooth'
                });

                header.classList.remove(toggleClass);
            }
        });
    });
});



let isFullWidth = false;

function toggleWidth() {
    const body = document.querySelector('body');
    const toggleButton = document.getElementById('toggleButton');
    
    isFullWidth = !isFullWidth;
    
    if (isFullWidth) {
        toggleButton.classList.add('active');
        body.classList.add('full-width');
    } else {
        toggleButton.classList.remove('active');
        body.classList.remove('full-width');
    }
}